import heading from "./heading";

export default function access() {
  const target = document.querySelector(".is-privacy");

  if (!target) return;

  heading();
}
